import { buildApiUrl } from '../../../config.js';
import React from "react";
import jsPDF from "jspdf";
import axios from "axios";
import autoTable from 'jspdf-autotable';

const PDFUploader = ({ orderData, token, selectedClient }) => {
    const generatePDFAndUpload = async () => {
        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

        // Title
        doc.setFontSize(28);
        doc.setFont("helvetica", "bold");
        doc.text("ESTIMATE", doc.internal.pageSize.width / 2, 20, { align: "center" });

        // Reference and Date
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Ref No. ${orderData.refNo || ""}`, 15, 30);
        doc.text(`Dated - ${new Date().toLocaleDateString()}`, doc.internal.pageSize.width - 55, 30, { align: "right" });

        // TO and FROM
        doc.setFont("helvetica", "bold");
        doc.text("TO,", 15, 40);
        doc.text("FROM", doc.internal.pageSize.width - 40, 40, { align: "right" });

        doc.setFont("helvetica", "normal");
        doc.text(selectedClient.firmName.toUpperCase(), 15, 50);
        doc.text("Kiyo International", doc.internal.pageSize.width - 40, 50, { align: "right" });

        // Remarks Box
        doc.text("Remarks:", 15, 60);
        doc.setDrawColor(200, 200, 200);
        doc.rect(15, 63, doc.internal.pageSize.width - 30, 10);
        doc.text(`Kind Attn ${selectedClient.firmName.toUpperCase()}`, 15, 75);
        doc.text("Dear Sir,", 15, 82);

        const message = "With reference to our telephonic discussion and rate quote by you. We are pleased to place an order as follows:";
        doc.setFontSize(9);
        doc.text(message, 15, 89, { maxWidth: doc.internal.pageSize.width - 30 });

        // Table Headers
        const headers = [["Sr. No.", "Item Code", "Item Description", "Unit", "Image", "Qty."]];

        // Table Data
        const data = orderData.items.map((item, index) => [
            index + 1,
            item.itemCode,
            item.itemName,
            "Box",
            "",  // Placeholder for image
            item.qty,
        ]);

        // Table Styling
        autoTable(doc, {
            head: headers,
            body: data,
            startY: 100,
            theme: "grid",
            headStyles: {
                fillColor: [0, 112, 192],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                halign: "center",
            },
            styles: {
                fontSize: 9,
                cellPadding: 1,
                lineColor: [200, 200, 200],
                lineWidth: 0.3,
                halign: "center",
                valign: "middle",
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 25 },
                2: { cellWidth: 75 },
                3: { cellWidth: 20 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
            },
            didDrawCell: (data) => {
                if (data.section === "body" && data.column.index === 4) {
                    const item = orderData.items[data.row.index];
                    if (item.imageUrl) {
                        const image = new Image();
                        image.crossOrigin = "anonymous";
                        image.src = item.imageUrl;
                        doc.addImage(image, "JPEG", data.cell.x + 2, data.cell.y + 2, 16, 16);
                    }
                }
            },
        });

        // Footer
        doc.setFontSize(8);
        doc.text("Thank you for your business!", doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: "center" });

        // Save PDF
        // doc.save("estimate.pdf');
          const pdfBlob = doc.output("blob");
        try {
          const formData = new FormData();
          formData.append("file", pdfBlob);
          formData.append("upload_preset", "your_cloudinary_preset");
      
          const response = await axios.post(
            buildApiUrl('/api/upload/upload'),
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          return response.data.fileUrls[0];
        } catch (error) {
          console.error("Error uploading PDF:", error);
          throw new Error("Error uploading PDF");
        }
    };

    return {
        generatePDFAndUpload,
    };
};

export default PDFUploader;




  // If uploading to server, use this code (commented out for now)
        // const pdfBlob = doc.output("blob");
        // try {
        //   const formData = new FormData();
        //   formData.append("file", pdfBlob);
        //   formData.append("upload_preset", "your_cloudinary_preset");
      
        //   const response = await axios.post(
        //     buildApiUrl('/api/upload/upload'),
        //     formData,
        //     {
        //       headers: {
        //         Authorization: `Bearer ${token}`,
        //         "Content-Type": "multipart/form-data",
        //       },
        //     }
        //   );
        //   return response.data.fileUrls[0];
        // } catch (error) {
        //   console.error("Error uploading PDF:", error);
        //   throw new Error("Error uploading PDF");
        // }